<!-- 档案审批记录 -->
<template>
  <div class="file-approve-log-container">
    <el-dialog
      title="档案审批记录"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      width="960px"
      top="7vh"
      class="dialog-main"
      :close-on-click-modal="false"
      @close="closeLog"
    >
       <!-- 按钮 -->
      <div class="code-staff-search">
        <el-select v-model="getListParams.spStatus" placeholder="状态" size="mini" @change="selectBindStatus" style="width: 140px; margin-right: 10px ">
          <el-option
            v-for="item in statusOptions"
            :key="item.bindStatus"
            :label="item.label"
            :value="item.bindStatus"
          >
          </el-option>
        </el-select>
        <el-select v-model="getListParams.bindType" placeholder="申请类型" size="mini" @change="selectBindStatus2" style="width: 140px; margin-right: 10px ">
          <el-option
            v-for="item in applicationOptions"
            :key="item.bindStatus"
            :label="item.label"
            :value="item.bindStatus"
          >
          </el-option>
        </el-select>
        <el-tag class="select-stafft-wrap" title="选择员工"  :closable="searchMenNames.length===0?false:true" @close="searchCloseTag" type="medium" effect="plain" @click="clickAddMember()">
          <span v-if="searchMenNames.length===0">选择员工</span>
          <span class="staff-names" v-for="(item,index) in searchMenNames" :key="index">{{item.name}}<span v-show="searchMenNames.length>1&&index!=searchMenNames.length-1">,</span></span>
        </el-tag>
      </div>
      <!-- 表格 -->
      <template>
        <el-table
          size="small"
          :data="tableData"
          fit
          highlight-current-row
          align="center"
          :header-cell-style="{ background: '#F9F9F9' }"
          height="calc(100vh - 180px - 14vh)"
          ref="cusChatTable"
          style="font-size: 13px"
        >
          <el-table-column label="客户" min-width="300">
            <template slot-scope="scope">
              <div>
              <el-row :gutter="20">
                <el-col :span="30" style="padding:0">
                  <el-avatar size="medium" shape="square" :src="scope.row.avatar"></el-avatar>
                </el-col>
                <el-col :span="70" >
                  <div style="color: black" v-if="scope.row.ctmName != null">{{scope.row.ctmName}}</div>
                  <div style="color: black" v-else>无绑定职称</div>
                  <div style="color: #a09f9fc9; font-size: 12px;">{{scope.row.nickName}}<span style="color: rgb(70, 189, 10)" v-if="scope.row.type == 1 "> @微信</span><span style="color: rgb(8, 168, 231)" v-else > @{{scope.row.corpName}}</span></div>
                </el-col>
              </el-row>
            </div>
            </template>
          </el-table-column>
          <el-table-column  label="状态" min-width="120">
            <template slot-scope="scope">
              <div>
                <el-tag size="small" v-if="scope.row.spStatus == 1" >审批中</el-tag>
                <el-tag size="small" type="success" v-if="scope.row.spStatus == 2">已通过</el-tag>
                <el-tag size="small" type="danger" v-if="scope.row.spStatus == 3">已驳回</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="申请类型" min-width="130">
            <template slot-scope="scope">
              <div>
                <span>{{scope.row.bindType == 1?'档案绑定':'档案解绑'}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="applyName"
            label="申请员工"
            min-width="130"
          ></el-table-column>
          <el-table-column
            prop="applyTime"
            label="提交时间"
            min-width="150"
          ></el-table-column>
          <el-table-column label="操作" min-width="120">
            <template slot-scope="scope">
              <el-button
                v-if="true"
                class="table-button"
                type="text"
                size="small"
                @click.stop="handleDetail(scope.$index, scope.row)"
                >详情</el-button
              >
              </template>
          </el-table-column>
        </el-table>
      </template>
      <Pagination
        :childMsg="pageparm"
        :pageSizes="pageSizes"
        @callBack="callBack"
      ></Pagination>
    </el-dialog>
   <!-- 添加人员树 -->
    <!-- <AddMemberView title="选择成员" :dialogVisibleTree="dialogVisibleTree" :currentSelectMember='currentSelectMember' @closeTree='closeTree' @clickSubmitTree='clickSubmitTree'></AddMemberView> -->
    <StaffTree title="选择成员" :dialogVisibleTree="dialogVisibleTree" :currentSelectMember='currentSelectMember' @closeTree='closeTree' @clickSubmitTree='clickSubmitTree' ></StaffTree>
    <!-- 档案详情 -->
    <FileDetai :visiAble="detailVisiAble" :detailItem="detailParams" @closeDetail="closeDetail"></FileDetai>
  </div>
</template>

<script>
import {approveList} from '@/api/customer/fileOp.js'
import AddMemberView from "@/views/code/components/addMember.vue"
import StaffTree from '@/components/staffTree/staffTree.vue'
import FileDetai from "@/views/customer/components/fileDetai.vue"
export default {
  name: 'FileApproveLog',
  props:["visiable"],
  components: {
    // AddMemberView,
    StaffTree,
    FileDetai
  },
  data() {
    return {
      detailVisiAble: false,
      detailParams: {},
      dialogVisible: false,
      tableData: [],
      dialogVisibleTree:false,
      currentSelectMember: [],                                // 当前选中的成员树
      statusOptions: [
        {
          bindStatus: '',
          label: "全部",
        },
        {
          bindStatus: 1,
          label: "审批中",
        },
        {
          bindStatus: 2,
          label: "已通过",
        },
        {
          bindStatus: 3,
          label: "已驳回",
        },
      ],
      applicationOptions: [
        {
          bindStatus: '',
          label: "全部",
        },
        {
          bindStatus: 1,
          label: "档案绑定",
        },
        {
          bindStatus: 0,
          label: "档案解绑",
        },
      ],
      getListParams: {
        spStatus: '',          //审批状态  1-审批中；2-已通过；3-已驳回
        bindType: '',          //绑定类型 0-解绑; 1-绑定
        userIdList: [],       //员工id集合        ]  
        pageNum: 1,           //页码 不传默认为1
        pageSize: 20,         //每页条数 不传默认为10
      },
      searchMenNames:[], //当前 搜索框-选中的成员
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      pageSizes: [20, 50, 100, 200, 500], //分页条数
    }
  },
  created() {
    this.getApproveList(this.getListParams)
  },
  methods: {
    closeDetail() {
      this.detailVisiAble = false
    },
    closeLog() {
      this.$emit("closeLog");
    },
    selectBindStatus(value) {
      this.getListParams.spStatus = value
      this.searchFn()
    },
    // 搜索-添加成员
    clickAddMember(){
      this.dialogVisibleTree = true;
    },
    // 申请类型
    selectBindStatus2(value) {
      this.getListParams.bindType = value
      this.searchFn()
    },
    searchFn() {
      this.getListParams.pageNum = 1
      this.getApproveList(this.getListParams)
    },
    // 树关闭
    closeTree(val){
      this.dialogVisibleTree = false;
    },
    // 详情
    handleDetail(index,item) {
      item.detailType = 1
      this.detailParams = JSON.parse(JSON.stringify(item))
      this.detailVisiAble = true
    },
    // 成员树的事件
    clickSubmitTree(val){
      this.searchMenNames = [];
      this.currentSelectMember = val.currentMember;
      this.dialogVisibleTree = false;
      this.getListParams.userIdList = [];
      val.sendArray.forEach(item => {
        let obj = {
          userId: item.userId,
          name: item.userName
        }
        this.searchMenNames.push(obj)
        this.getListParams.userIdList.push(item.userId)
      })
      // 发送请求
      this.searchFn()
    },
    // 搜索-添加成员---清空
    searchCloseTag(){
      this.searchMenNames = [];
      this.currentSelectMember = []
      this.getListParams.userIdList = []
      this.searchFn()
    },
    callBack(parm) {
      this.getListParams.pageNum = parm.currentPage;
      this.getListParams.pageSize = parm.pageSize;
      this.getApproveList(this.getListParams);
    },
    getApproveList(params) {
      approveList(params,localStorage.getItem("Authorization"),true).then(res => {
        if(res.error.code == 200) {
          this.pageparm.total = res.data.total
          this.tableData = res.data.rows
          this.pageparm.currentPage = this.getListParams.pageNum
          this.pageparm.pageSize = this.getListParams.pageSize
        }else {
          this.$message.error("获取档案审批日志失败,请重试！");
        }
      })
    }
  },
  watch: {
    visiable: {
      handler(newVal,oldVal) {
        this.dialogVisible = newVal
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.code-staff-search {
    display: flex;
    margin-bottom: 15px;
    /deep/.select-stafft-wrap{
      margin-right: 10px;
      width: 180px;
      position: relative;
      cursor: pointer;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      .el-icon-close{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 5px;
      }
      .staff-names {
        color: #606266;
      }
    }
    .el-tag--plain{
      border-color: #DCDFE6;
      color: #C0C4CF;
    }
  }
</style>